import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button, Form } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
// ;
import funciones from '../../middleware/funciones';
import config from '../../config';
import Mensajes from '../subcomponent/mensajes';
import BackButton from '../widgets/back_button';
import ModalCompanyModules from '../subcomponent/companyModuleModal';
import ModalCompanyCreate from '../subcomponent/companyModuleCreateCompany';

class EmpresasAdmin extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        //const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            datos: [],
            empresa: currentCompany,
            search: "",
            mostrarMensaje: false,
            mensaje: ""
        };
    }
    componentDidMount() {
        this.init();
    }

    init = () => {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa
            }
        };
        fetch(config.servBackEnd + '/companies/', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    this.setState({ datos });
                } else {
                    //console.log(data.message);
                }
            });
    }

    changestatecompany = (code, state) => {
        const newstate = (state === '1') ? 0 : 1;
        const texto = (state === '1') ? "Inactivando" : "Activando";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                code,
                newstate
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        fetch(config.servBackEnd + '/companies/changestate', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.init();
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Error " + texto + " Empresa: " + data.message })
                }
            });
    }

    after_create = (data) => {
        if (data.ok) {
            this.init();
            this.setState({ mostrarMensaje: true, mensaje: "Empresa Creada Correctamente" })
        } else {
            this.setState({ mostrarMensaje: true, mensaje: data.message })
        }
    }

    render() {
        const dato = (this.state.datos) ? this.state.datos : [];

        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };
        const { search } = this.state;
        const changestatecompany = this.changestatecompany
        return (

            <div className="contenedor">

                <div>
                    <Jumbotron style={style}>
                        <h1>Administrar Empresas</h1>
                    </Jumbotron>
                    <BackButton />
                    <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Control value={search} onChange={(e) => this.setState({ search: e.target.value })} type="text" placeholder="Search" />
                    </Form.Group>
                    <ModalCompanyCreate callback={this.after_create} />
                    <Table hover bordered responsive size="sm" className="table">
                        <thead>
                            <tr>
                                <th>Empresa</th>
                                <th>Nombre Empresa</th>
                                <th>Fecha Vencimiento Token</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>

                            {dato.map(function (currentData, index) {
                                if (currentData.ID_EMPRESA.toLowerCase().search(search.toLowerCase()) > -1
                                    || currentData.RAZON_SOCIAL.toLowerCase().search(search.toLowerCase()) > -1) {
                                    return <tr key={index + "d0"}>
                                        <td key={index + "d2"}>{currentData.ID_EMPRESA}</td>
                                        <td key={index + "d4"}>{currentData.RAZON_SOCIAL}</td>
                                        <td key={index + "d5"}>{currentData.TOKEN_FECHA_VENCIMIENTO}</td>
                                        <td key={index + "d14"}>{funciones.textEstadoGeneral(currentData.ESTADO)}</td>
                                        <td key={index + "d15"}><Button size="sm" onClick={() => changestatecompany(currentData.ID_EMPRESA, currentData.ESTADO)} variant={(currentData.ESTADO === '1') ? "outline-danger" : "outline-success"}>{(currentData.ESTADO === '1') ? "Inactivar" : "Activar"}</Button></td>
                                        <td><ModalCompanyModules company_name={currentData.RAZON_SOCIAL} company_code={currentData.ID_EMPRESA} /></td>
                                    </tr>;
                                } else {
                                    return null;
                                }
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>




        );
    }
}
export default (EmpresasAdmin);


// WEBPACK FOOTER //
// ./src/components/configuracion/empresaadmin.jsx